module.exports = __webpack_public_path__ + "static/media/ornament.da3f38ef.svg";